import React from 'react';
import Drawer from './Drawer';

type DrawerPortalProps = React.ComponentProps<typeof Drawer>;

const DrawerPortal = (props: DrawerPortalProps) => {
	const { active } = props;

	return active ? <Drawer {...props} /> : null;
};

export default DrawerPortal;
